import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let CodeEntryComponent = class extends Mixins(validationMixin, MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.digits = [];
    this.currentField = null;
  }
  handleInput(index) {
    const value = this.digits[index].digit || "";
    const nextIndex = index + 1;
    if (this.digits.length > nextIndex && value.length === 1 && !isNaN(+value)) {
      this.currentField = nextIndex;
    }
  }
  handleDelete(event, index) {
    const field = this.digits[index].digit;
    const prevIndex = index - 1;
    if (prevIndex >= 0 && (field === "" || field === null)) {
      event.detail[0].preventDefault();
      this.currentField = prevIndex;
    }
  }
  digitLengthChange() {
    this.digits = new Array(this.length).fill(null).map(() => ({ digit: null }));
  }
  onValueChange(value) {
    if (value === null || value === void 0) {
      return;
    }
    const splitArr = value.split("").map((digit) => ({ digit }));
    this.digits = splitArr.concat(Array(this.length - value.length).fill(null).map(() => ({ digit: null })));
  }
  digitsChanged(digits) {
    const code = digits.map(({ digit }) => digit).join("");
    return code;
  }
};
__decorateClass([
  Prop({ type: Number, default: 4 })
], CodeEntryComponent.prototype, "length", 2);
__decorateClass([
  Prop(String)
], CodeEntryComponent.prototype, "value", 2);
__decorateClass([
  Watch("length", { immediate: true })
], CodeEntryComponent.prototype, "digitLengthChange", 1);
__decorateClass([
  Watch("value", { immediate: true })
], CodeEntryComponent.prototype, "onValueChange", 1);
__decorateClass([
  Watch("digits", { deep: true }),
  Emit("change")
], CodeEntryComponent.prototype, "digitsChanged", 1);
CodeEntryComponent = __decorateClass([
  Component({
    name: "ui-code-entry",
    validations: {
      digits: {
        $each: {
          digit: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(1)
          }
        }
      }
    }
  })
], CodeEntryComponent);

export default CodeEntryComponent;
